import { RouterState, routerReducer } from '@ngrx/router-store';
import { ActionReducerMap, MetaReducer } from '@ngrx/store';

import { environment } from '../../../environments/environment';
import { CoreState } from '../models/core.types';

import * as fromCore from './core.reducer';
import * as fromFatalError from './fatal-error.reducer';
import { storageMetaReducer } from './storage.metareducer';

export interface State {
    [fromCore.coreFeatureKey]: CoreState;
    [fromFatalError.fatalErrorFeatureKey]: fromFatalError.State;
    router: RouterState;
}

export const reducers: ActionReducerMap<State> = {
    [fromCore.coreFeatureKey]: fromCore.reducer,
    [fromFatalError.fatalErrorFeatureKey]: fromFatalError.reducer,
    router: routerReducer,
};

export const metaReducers: MetaReducer<State>[] = [
    storageMetaReducer,
    ...(!environment.production ? [] : []), // eslint-disable-line sonarjs/no-all-duplicated-branches
];
